import types from '@/vuex/arquivos-documento/mutations-types'

const mutations = {
  [types.SET_LISTA_MOTIVOS_RESTRICOES_ARQUIVO]: (state, payload) => {
    state.listaMotivosRestricoesArquivo = payload.listaMotivosRestricoesArquivo
  },
  [types.SET_LISTA_ARQUIVOS]: (state, payload) => {
    state.listaArquivos = payload.listaArquivos
  },
  [types.SET_LISTA_PECAS]: (state, payload) => {
    state.listaPecas = payload.listaPecas
  },
  [types.SET_ARQUIVO]: (state, payload) => {
    state.arquivo = payload.arquivo
  },
  [types.SET_ARQUIVO_BLOB_URL]: (state, payload) => {
    state.arquivoBlobURL = payload.arquivoBlobURL
  },
  [types.SET_SITUACAO_VINCULO]: (state, payload) => {
    state.situacaoVinculo = payload.situacaoVinculo
  },
  [types.SET_LISTA_DOCUMENTOS]: (state, payload) => {
    state.listaDocumentos = payload.listaDocumentos
  },
  [types.SET_DOCUMENTO_SELECIONADO]: (state, payload) => {
    state.documentoSelecionado = payload.documentoSelecionado
  },
  [types.SET_JUSTIFICATIVA_CANCELAMENTO]: (state, payload) => {
    state.justificativaCancelamento = payload.justificativaCancelamento
  },
  [types.SET_PASSO_ATUAL]: (state, payload) => {
    state.passoAtual = payload.passoAtual
  },
  [types.SET_LISTA_ARQUIVOS_ASSINADOS_NAO_VINCULADOS]: (state, payload) => {
    state.listaArquivosAssinadosNaoVinculados = payload.listaArquivosAssinadosNaoVinculados
  },
  [types.REMOVER_ARQUIVO_LISTA]: (state, payload) => {
    state.listaPecas.splice(payload.arquivoSelecionadoIndex, 1)
    state.listaPecas.forEach(peca => {
      if (peca.sequencial > payload.arquivoSelecionado.sequencial) {
        Object.assign(peca, {sequencial: peca.sequencial - 1})
      }
    })
  },
  [types.ALTERAR_PECA_LISTA]: (state, payload) => {
    state.listaPecas.splice(payload.arquivoSelecionadoIndex, 1, payload.arquivo)
  },
  [types.SHOW_EDICAO_ARQUIVO_DIALOG]: (state) => {
    state.arquivoEdicaoDialog = true
  },
  [types.HIDE_EDICAO_ARQUIVO_DIALOG]: (state) => {
    state.arquivoEdicaoDialog = false
  },
  [types.SHOW_CANCELAMENTO_PECA_DIALOG]: (state) => {
    state.cancelamentoPecaDialog = true
  },
  [types.HIDE_EXCLUSAO_ARQUIVO_DIALOG]: (state) => {
    state.cancelamentoPecaDialog = false
  },
  [types.SHOW_ADICIONAR_ARQUIVO_ASSINADO_DIALOG]: (state) => {
    state.adicionarArquivoAssinadoDialog = true
  },
  [types.HIDE_ADICIONAR_ARQUIVO_ASSINADO_DIALOG]: (state) => {
    state.adicionarArquivoAssinadoDialog = false
  },
  [types.SHOW_INFORMACOES_PECAS_UPLOAD_DIALOG]: (state) => {
    state.informacoesPecasUploadDialog = true
  },
  [types.HIDE_INFORMACOES_PECAS_UPLOAD_DIALOG]: (state) => {
    state.informacoesPecasUploadDialog = false
  },
  [types.ALTERAR_SEQUENCIAL]: (state, payload) => {
    let pecas = state.listaPecas.slice().sort((a, b) => a.sequencial - b.sequencial)
    let sequencialAntigo = +(payload.sequencialAntigo)
    let novoSequencial = +(payload.novoSequencial)

    pecas[sequencialAntigo - 1].sequencial = novoSequencial
    if (sequencialAntigo > novoSequencial) {
      pecas.slice(novoSequencial - 1, sequencialAntigo - 1).forEach((p) => { p.sequencial = p.sequencial + 1 })
    } else if (sequencialAntigo < novoSequencial) {
      pecas.slice(sequencialAntigo, novoSequencial).forEach((p) => { p.sequencial = p.sequencial - 1 })
    }
  }

}
export default mutations



// WEBPACK FOOTER //
// ./src/vuex/arquivos-documento/mutations.js